import React from 'react';
import { Controller } from 'react-hook-form';
import ReactStars from 'react-rating-stars-component';
import cx from 'classnames';
import { getFormRules } from 'helpers';
import StarOutlinedIcon from '@material-ui/icons/StarOutlined';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import StarHalfOutlinedIcon from '@material-ui/icons/StarHalfOutlined';

const RateInput = ({ item, errors, handleFocus, control, watch, trigger, handleRatingChange, value }) => {
    const itemClasses = cx('review__form--item', {
        'is-invalid': !!errors[item.name],
    });
    const props = {
        emptyIcon: <StarBorderOutlinedIcon />,
        halfIcon: <StarHalfOutlinedIcon />,
        filledIcon: <StarOutlinedIcon />,
    };
    return (
        <div className={itemClasses}>
            <label>{item.label}</label>
            <div className="review__rate">
                <ReactStars
                    name={item.name}
                    count={5}
                    onChange={(e) => handleRatingChange({ name: item.name, value: e })}
                    size={32}
                    {...props}
                    color="#999999"
                    activeColor={'#f7b526'}
                />

                <Controller
                    render={({ value }) => {
                        return <input name={item.name} value={value} type={'hidden'} />;
                    }}
                    control={control}
                    name={item.name}
                    rules={getFormRules({ items: item.rules, watch })}
                    defaultValue={value || ''}
                />
            </div>
        </div>
    );
};

export default RateInput;
